"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Handlebars = void 0;

var url_to_array = void 0;
var bind = function bind(fn, me) {
    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return fn.apply(me, args);
    };
};
var indexOf = [].indexOf || function (item) {
    for (var i = 0, l = this.length; i < l; i++) {
        if (i in this && this[i] === item) return i;
    }
    return -1;
};

Handlebars = require("handlebars");

url_to_array = require("../helpers/url_to_array");

var Upload = function Upload() {
    _classCallCheck(this, Upload);

    var SubmitIcons = void 0;
    var Upload_Carousel = void 0;
    var start = void 0;
    (0, _jquery2.default)(".upload-form").on("submit", function (e) {
        e.preventDefault();
    });

    Upload_Carousel = function () {
        var Upload_Carousel = function () {
            function Upload_Carousel(element) {
                _classCallCheck(this, Upload_Carousel);

                this.element = element;
                this.buttons = this.element.find("button[data-slide-to]");
                this.upload_individual = (0, _jquery2.default)(".upload-an-individual");
                this.upload_collection = (0, _jquery2.default)(".upload-a-collection");
                this.slides = (0, _jquery2.default)(".carousel-inner").children();
                this.current_slide_number = 2;
                this.update_buttons();
                this.buildPage();
            }

            _createClass(Upload_Carousel, [{
                key: "buildPage",
                value: function buildPage() {
                    var $current_slide = void 0;
                    var $next_slide = void 0;
                    if (url_to_array[4] === "options") {
                        if (url_to_array[5] === "icon") {
                            $current_slide = (0, _jquery2.default)(this.slides[0]);
                            $next_slide = (0, _jquery2.default)(this.slides[3]);
                            $current_slide.addClass("active");
                            start("individual");
                            return this.move($current_slide, $next_slide);
                        } else if (url_to_array[5] === "collection") {
                            $current_slide = (0, _jquery2.default)(this.slides[0]);
                            $next_slide = (0, _jquery2.default)(this.slides[2]);
                            $current_slide.addClass("active");
                            start("collection");
                            return this.move($current_slide, $next_slide);
                        } else {
                            return this.update((0, _jquery2.default)("button[data-slide-to='1']"));
                        }
                    }
                }
            }, {
                key: "update_buttons",
                value: function update_buttons() {
                    var me = void 0;
                    me = this;
                    this.buttons.on("click", function (e) {
                        var $this = void 0;
                        $this = (0, _jquery2.default)(this);
                        return me.update($this);
                    });
                    this.upload_individual.on("click", function (e) {
                        e.preventDefault();
                        start("individual");
                        return me.upload_type_slide("individual");
                    });
                    return this.upload_collection.on("click", function (e) {
                        e.preventDefault();
                        start("collection");
                        return me.upload_type_slide("collection");
                    });
                }
            }, {
                key: "get_slide",
                value: function get_slide(slide_number) {
                    this.current_slide_number = slide_number - 1;
                    return this.slides[this.current_slide_number];
                }
            }, {
                key: "update",
                value: function update(go_to_slide) {
                    var $current_slide = void 0;
                    var $next_slide = void 0;
                    $current_slide = (0, _jquery2.default)(this.get_slide(go_to_slide.data("slide-to")));
                    $next_slide = $current_slide.next();
                    return this.move($current_slide, $next_slide);
                }
            }, {
                key: "move",
                value: function move($current_slide, $next_slide) {
                    $current_slide.addClass("left");
                    $next_slide.addClass("next");
                    setTimeout(function () {
                        return $current_slide.removeClass("active left");
                    }, 300);
                    return setTimeout(function () {
                        $next_slide.removeClass("next");
                        return $next_slide.addClass("active");
                    }, 150);
                }
            }, {
                key: "upload_type_slide",
                value: function upload_type_slide(upload_type) {
                    var $current_slide = void 0;
                    var $next_slide = void 0;
                    $current_slide = (0, _jquery2.default)(this.slides[1]);
                    if (upload_type === "individual") {
                        $next_slide = (0, _jquery2.default)(this.slides[3]);
                    } else {
                        $next_slide = (0, _jquery2.default)(this.slides[2]);
                    }
                    return this.move($current_slide, $next_slide);
                }
            }]);

            return Upload_Carousel;
        }();

        return Upload_Carousel;
    }();
    SubmitIcons = function () {
        var SubmitIcons = function () {
            function SubmitIcons(container, upload_type1, brief_id1) {
                _classCallCheck(this, SubmitIcons);

                this.container = container;
                this.upload_type = upload_type1;
                this.brief_id = brief_id1;
                this._init = bind(this._init, this);
                this.container = (0, _jquery2.default)(this.container);
                this.upload_collection = this.upload_type === "collection" ? true : false;
                this.pending_icons = void 0;
                this.current = 2;
                this.upload_url = "/upload/ajax/";
                this.icon_forms = void 0;
                this.dropZone = void 0;
                this.lowerHalf = void 0;
                this.submit_icons = void 0;
                this.file_input = void 0;
                this.file_api_URL = window.URL || window.URL;
                this.template = Handlebars.compile((0, _jquery2.default)("#icon-form-template").html());
                this.collection_id = void 0;
                this.brief_id = this.brief_id;
                this.pending_tags = [];
                this.pending_license = void 0;
                this.tabindex = 100;
                this.min_tags = 1;
                this.max_tags = 5;
                (0, _jquery2.default)(".load-more-icons ").on("click", function (_this) {
                    return function () {
                        return _jquery2.default.ajax({
                            url: "/upload/pending/?page=" + _this.page,
                            data: {
                                brief_id: brief_id
                            },
                            success: function success(_ref) {
                                var icons = _ref.icons,
                                    total_icons = _ref.total_icons;

                                _this.page = _this.page + 1;
                                return _this.set_pending_icons(icons, total_icons);
                            }
                        });
                    };
                }(this));
            }

            _createClass(SubmitIcons, [{
                key: "_init",
                value: function _init(unbind) {
                    if (unbind == null) {
                        unbind = false;
                    }
                    if (this.upload_type === "individual") {
                        this.upload_individual_init(unbind);
                        this.current = 4;
                        this.upload_individual = true;
                    }
                    if (this.upload_type === "collection") {
                        this.upload_collection_init(unbind);
                        this.current = 3;
                        this.upload_individual = false;
                    }
                    if (this.upload_type === "brief") {
                        this.upload_individual_init(unbind);
                        this.current = 0;
                        this.upload_individual = true;
                    }
                    return this.shared_init(unbind);
                }
            }, {
                key: "set_pending_icons",
                value: function set_pending_icons(icons, total_icons) {
                    var i = void 0;
                    var icon = void 0;
                    var len = void 0;
                    var ref = void 0;
                    this.pending_icons = icons;
                    this.total_icons = total_icons;
                    ref = this.pending_icons;
                    for (i = 0, len = ref.length; i < len; i++) {
                        icon = ref[i];
                        this.add_icon_form(icon);
                    }
                    return this.checkNumUploads();
                }
            }, {
                key: "shared_init",
                value: function shared_init(unbind) {
                    var events = void 0;
                    var si = void 0;
                    if (unbind == null) {
                        unbind = false;
                    }
                    si = this;
                    events = {
                        docDragDrop: function (_this) {
                            return function (e) {
                                var file = void 0;
                                var files = void 0;
                                var i = void 0;
                                var len = void 0;
                                var results = void 0;
                                e.stopPropagation();
                                e.preventDefault();
                                _this.container.removeClass("active-target");
                                files = e.originalEvent.dataTransfer.files;
                                results = [];
                                for (i = 0, len = files.length; i < len; i++) {
                                    file = files[i];
                                    results.push(_this.uploadFile(file, _this.prepareFile(file)));
                                }
                                return results;
                            };
                        }(this),
                        dropZoneClick: function dropZoneClick(e) {
                            e.preventDefault();
                            return si.file_input.click();
                        }
                    };
                    (0, _jquery2.default)(document).on("drageenter", function (_ref2) {
                        var container = _ref2.container;
                        return function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            container.addClass("active-target");
                            return e.originalEvent.dataTransfer.effect = "copy";
                        };
                    }(this));
                    (0, _jquery2.default)(document).on("dragleave", function (_ref3) {
                        var container = _ref3.container;
                        return function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            return container.removeClass("active-target");
                        };
                    }(this));
                    (0, _jquery2.default)(document).on("dragover", function (_ref4) {
                        var container = _ref4.container;
                        return function (e) {
                            e.preventDefault();
                            return container.addClass("active-target");
                        };
                    }(this));
                    document.proxy = _jquery2.default.proxy(events, "docDragDrop");
                    (0, _jquery2.default)(document).on("drop", document.proxy);
                    this.container.on("keydown", "input.suggested-noun", function (_ref5) {
                        var shiftKey = _ref5.shiftKey,
                            keyCode = _ref5.keyCode;

                        var neighbor = void 0;
                        var parent = void 0;
                        if ((0, _jquery2.default)(this).val().length > 0) {
                            (0, _jquery2.default)(this).siblings(".after-noun-added").addClass("is_ready");
                            (0, _jquery2.default)(this).parents(".icon-form").removeClass("empty-term");
                        } else {
                            (0, _jquery2.default)(this).siblings(".after-noun-added").removeClass("is_ready");
                        }
                        if (!shiftKey && keyCode === 9) {
                            parent = (0, _jquery2.default)(this).parents(".flip-container");
                            if (parent.hasClass("flip")) {
                                return console.log("Already flipped");
                            } else {
                                return parent.addClass("flip");
                            }
                        } else if (shiftKey && keyCode === 9) {
                            parent = (0, _jquery2.default)(this).parents(".flip-container");
                            neighbor = parent.prev(".flip-container");
                            if (neighbor.hasClass("flip")) {
                                return console.log("Already flipped");
                            } else {
                                return neighbor.addClass("flip");
                            }
                        }
                    });
                    this.container.on("blur", "input.suggested-noun", function (e) {
                        var parent = void 0;
                        parent = (0, _jquery2.default)(this).parents(".flip-container");
                        if (!parent.hasClass("flip") && (0, _jquery2.default)(this).val().length > 0) {
                            return parent.addClass("flip");
                        }
                    });
                    this.container.on("keydown", "input.keywords-field", function (_ref6) {
                        var keyCode = _ref6.keyCode;

                        var parent = void 0;
                        if (keyCode === 9) {
                            parent = (0, _jquery2.default)(this).parents(".flip-container");
                            return parent.removeClass("flip");
                        }
                    });
                    this.container.delegate(".flip-anchor", "click", function (e) {
                        var parent = void 0;
                        e.preventDefault();
                        parent = (0, _jquery2.default)(this).parents(".card");
                        parent.addClass("flip");
                        return parent.find("keywords-field").focus();
                    });
                    this.container.delegate(".un-flip", "click", function (e) {
                        var parent = void 0;
                        e.preventDefault();
                        parent = (0, _jquery2.default)(this).parents(".card");
                        return parent.removeClass("flip");
                    });
                    this.container.delegate("input[name=suggested-noun]", "blur", function (e) {
                        return si.saveKeywords((0, _jquery2.default)(this));
                    });
                    this.container.delegate(".keywords-field", "keydown", function (e) {
                        if (e.which === 13 || e.which === 9) {
                            e.preventDefault();
                            e.stopPropagation();
                            return si.handleKeywords(this);
                        }
                    });
                    this.container.delegate(".collection-keywords-field", "keydown", function (e) {
                        if (e.which === 13 || e.which === 9) {
                            e.preventDefault();
                            e.stopPropagation();
                            return si.handleKeywords(this, true);
                        }
                    });
                    this.container.delegate(".delete-icon", "click", function (e) {
                        e.preventDefault();
                        if (!si.firingSubmit) {
                            return si.deleteIcon((0, _jquery2.default)(this));
                        }
                    });
                    this.container.delegate(".delete-keyword", "click", function (e) {
                        var icon_form = void 0;
                        e.preventDefault();
                        if (!si.firingSubmit) {
                            icon_form = (0, _jquery2.default)(this).closest("li.icon-form");
                            si.deleteKeyword((0, _jquery2.default)(this));
                            return si.saveKeywords(icon_form);
                        }
                    });
                    this.container.delegate("input.icon-radio:radio", "change", function (e) {
                        return si.saveKeywords((0, _jquery2.default)(this));
                    });
                    this.dropZone.proxy = _jquery2.default.proxy(events, "dropZoneClick");
                    this.dropZone.on("click", this.dropZone.proxy);
                    this.submit_icons.on("click", function (e) {
                        var upload_ids = void 0;
                        e.preventDefault();
                        (0, _jquery2.default)(".icon-form .keywords-field").each(function () {
                            return si.handleKeywords(this);
                        });
                        si.container.addClass("submitting");
                        (0, _jquery2.default)(this).addClass("processing");
                        upload_ids = si.validate_icon_data();
                        if (upload_ids) {
                            (0, _jquery2.default)(".error-box").fadeOut();
                            if (!si.iconsUploaded) {
                                si.firingSubmit = true;
                                return _jquery2.default.ajax({
                                    url: "/upload/submit/",
                                    method: "POST",
                                    data: {
                                        collection_id: si.collection_id,
                                        upload_ids: JSON.stringify(upload_ids)
                                    },
                                    success: function success(data) {
                                        var icon_forms_lis = void 0;
                                        si.iconsUploaded = true;
                                        si.container.removeClass("submitting");
                                        (0, _jquery2.default)(this).removeClass("processing").addClass("success");
                                        (0, _jquery2.default)(".cheers").addClass("visible");
                                        icon_forms_lis = si.icon_forms.find("li.icon-form");
                                        return icon_forms_lis.each(function () {
                                            (0, _jquery2.default)(this).addClass("remove");
                                            (0, _jquery2.default)("html, body").animate({
                                                scrollTop: 0
                                            }, 1000);
                                            return setTimeout(function (_this) {
                                                return function () {
                                                    (0, _jquery2.default)(_this).remove();
                                                    return si.checkNumUploads();
                                                };
                                            }(this), 600);
                                        });
                                    },
                                    error: function error() {
                                        return si.iconsUploaded = false;
                                    }
                                });
                            }
                        } else {
                            (0, _jquery2.default)(this).removeClass("processing");
                            return si.container.removeClass("submitting");
                        }
                    });
                    return this.container.delegate("#upload-more-icons", "click", function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        return location.href = e.target.attributes.href.value;
                    });
                }
            }, {
                key: "upload_individual_init",
                value: function upload_individual_init(unbind) {
                    var si = void 0;
                    if (unbind == null) {
                        unbind = false;
                    }
                    si = this;
                    this.icon_forms = (0, _jquery2.default)("#icon-forms");
                    this.dropZone = (0, _jquery2.default)("#drop-zone");
                    this.lowerHalf = (0, _jquery2.default)(".lower-half");
                    this.submit_icons = (0, _jquery2.default)("#submit-icons");
                    this.file_input = (0, _jquery2.default)("#file-input");
                    return this.container.delegate("input[name=icons]", "change", function (e) {
                        var file = void 0;
                        var i = void 0;
                        var len = void 0;
                        var ref = void 0;
                        var results = void 0;
                        e.preventDefault();
                        ref = this.files;
                        results = [];
                        for (i = 0, len = ref.length; i < len; i++) {
                            file = ref[i];
                            results.push(si.uploadFile(file, si.prepareFile(file)));
                        }
                        return results;
                    });
                }
            }, {
                key: "upload_collection_init",
                value: function upload_collection_init(unbind) {
                    var si = void 0;
                    if (unbind == null) {
                        unbind = false;
                    }
                    si = this;
                    this.icon_forms = (0, _jquery2.default)("#collection-icon-forms");
                    this.dropZone = (0, _jquery2.default)("#collection-drop-zone");
                    this.lowerHalf = (0, _jquery2.default)(".lower-half");
                    this.submit_icons = (0, _jquery2.default)("#collection-submit-icons");
                    this.file_input = (0, _jquery2.default)("#collection-file-input");
                    this.container.delegate("a.tab", "click", function (e) {
                        var selected = void 0;
                        var target = void 0;
                        e.preventDefault();
                        target = (0, _jquery2.default)(this).attr("href");
                        if (target === "#create-a-collection") {
                            si.toggleDropZone(false);
                            si.collection_id = void 0;
                            si.checkNumUploads();
                        }
                        (0, _jquery2.default)("a.tab").removeClass("active");
                        (0, _jquery2.default)(this).addClass("active");
                        selected = (0, _jquery2.default)(".collections-container").find("input:checked")[0];
                        if (selected) {
                            selected.checked = false;
                        }
                        (0, _jquery2.default)(".form-item").removeClass("active");
                        (0, _jquery2.default)(target).addClass("active");
                        return si.show_pending_tags("");
                    });
                    this.container.delegate("#collection-create", "click", function (e) {
                        var form = void 0;
                        e.preventDefault();
                        form = (0, _jquery2.default)(this).parent();
                        return si.createCollection(form, this);
                    });
                    this.container.on("keydown", "#new-collection-title", function (e) {
                        return (0, _jquery2.default)("#collection-create").removeClass("hidden");
                    });
                    this.container.delegate("input.collection-option:radio", "change", function (e) {
                        return si.handle_select_collection(e);
                    });
                    this.container.delegate(".delete-collection-keyword", "click", function (e) {
                        e.preventDefault();
                        si.deleteKeyword((0, _jquery2.default)(this));
                        return si.deleteKeyword((0, _jquery2.default)(this).parent().text(), true);
                    });
                    this.container.delegate("input[name=collection-icons]", "change", function (e) {
                        var file = void 0;
                        var i = void 0;
                        var len = void 0;
                        var ref = void 0;
                        var results = void 0;
                        e.preventDefault();
                        ref = this.files;
                        results = [];
                        for (i = 0, len = ref.length; i < len; i++) {
                            file = ref[i];
                            results.push(si.uploadFile(file, si.prepareFile(file)));
                        }
                        return results;
                    });
                    return this.container.delegate("input.collection-radio:radio", "change", function (e) {

                        if (e.currentTarget.id === "collection-license-cc") {}
                        if (e.currentTarget.id === "collection-license-pd") {}
                        si.pending_license = e.currentTarget.id;
                        si.collection_change_license(si.pending_license);
                        return si.saveCollection();
                    });
                }
            }, {
                key: "unbind",
                value: function unbind(e) {
                    this.container.undelegate();
                    this.container.off();
                    this.dropZone.off();
                    (0, _jquery2.default)(document).off("dragleave dragover drageenter");
                    return (0, _jquery2.default)(document).off("drop", document.proxy);
                }
            }, {
                key: "collection_change_license",
                value: function collection_change_license(license) {
                    var si = void 0;
                    si = this;
                    return (0, _jquery2.default)(".icon-form").each(function () {
                        var els = void 0;
                        els = (0, _jquery2.default)(this).find("input.icon-radio:radio");
                        if (license.substr(19, 2) === "cc") {
                            els[0].checked = true;
                        }
                        if (license.substr(19, 2) === "pd") {
                            els[1].checked = true;
                        }
                        return si.saveKeywords((0, _jquery2.default)(this));
                    });
                }
            }, {
                key: "prepareFile",
                value: function prepareFile(file) {
                    return this.add_icon_form({
                        status: "uploading",
                        svg_url: this.file_api_URL.createObjectURL(file),
                        keywords: [],
                        is_creative_commons: true,
                        is_public_domain: false,
                        collection_id: this.collection_id
                    });
                }
            }, {
                key: "collection_keywords",
                value: function collection_keywords() {
                    return (0, _jquery2.default)("form#create-collection-form").serializeObject().tags;
                }
            }, {
                key: "icon_keywords",
                value: function icon_keywords(card) {
                    var form = void 0;
                    form = (0, _jquery2.default)(card).parents("form");
                    return form.serializeObject().tags;
                }
            }, {
                key: "handleKeywords",
                value: function handleKeywords(el, collection) {
                    var added = void 0;
                    var form = void 0;
                    var hidden_field = void 0;
                    var i = void 0;
                    var input = void 0;
                    var keyword = void 0;
                    var keywords = void 0;
                    var keywords_ul = void 0;
                    var len = void 0;
                    var si = void 0;
                    var tags = void 0;
                    if (collection == null) {
                        collection = false;
                    }
                    if ((0, _jquery2.default)(el).val() !== "") {
                        si = this;
                        input = (0, _jquery2.default)(el);
                        keywords_ul = input.parent().find(".keywords");
                        form = input.parents("form");
                        tags = form.serializeObject().tags || [];
                        keywords = input.val().split(",");
                        added = [];
                        for (i = 0, len = keywords.length; i < len; i++) {
                            keyword = keywords[i];
                            keyword = keyword.replace("#", "").trim();
                            if (keyword !== "" && !added.includes(keyword)) {
                                this.addKeyword(keyword, keywords_ul, tags, collection);
                                hidden_field = "<input type='hidden' value='" + keyword + "' name='tags'>";
                                added.push(keyword);
                            }
                        }
                        if (collection) {
                            (0, _jquery2.default)(".icon-form").each(function () {
                                var group = void 0;
                                form = (0, _jquery2.default)(this).find("form.icon-form-form");
                                tags = form.serializeObject().tags || [];
                                group = (0, _jquery2.default)(this).find(".keywords");
                                return si.addKeyword(input.val(), group, tags, false);
                            });
                            this.pending_tags.push(input.val());
                        }
                        input.val("");
                        if (!collection) {
                            this.saveKeywords((0, _jquery2.default)(el));
                        }
                        if (collection) {

                            (0, _jquery2.default)(".icon-form").each(function () {
                                return si.saveKeywords((0, _jquery2.default)(this));
                            });
                            return this.saveCollection();
                        }
                    }
                }
            }, {
                key: "addKeyword",
                value: function addKeyword(keyword, group, current_keywords, collection) {
                    var hidden_field = void 0;
                    if (collection == null) {
                        collection = false;
                    }
                    hidden_field = "<input type='hidden' value='" + keyword + "' name='tags'>";
                    if (indexOf.call(current_keywords, keyword) < 0) {
                        return group.append("<li><span class='keyword'>" + keyword + "<a class='delete-" + (collection ? "collection-" : "") + "keyword ui_close' href='#'></a></span>" + hidden_field + "</li>");
                    }
                }
            }, {
                key: "handle_select_collection",
                value: function handle_select_collection(_ref7) {
                    var target = _ref7.target;

                    this.collection_id = (0, _jquery2.default)(target).val();
                    this.toggleDropZone(true);
                    this.pending_tags = [];
                    this.pending_tags = target.dataset.tags ? target.dataset.tags.split(" ") : void 0;

                    this.commit_pending_tags();
                    return this.show_pending_tags(this.pending_tags);
                }
            }, {
                key: "show_pending_tags",
                value: function show_pending_tags(keywords) {
                    var group = void 0;
                    var i = void 0;
                    var keyword = void 0;
                    var len = void 0;
                    var results = void 0;
                    group = (0, _jquery2.default)("#pending-collection-keywords");
                    group.html("");
                    group.hide();
                    if (keywords !== void 0) {
                        group.show();
                        group.append("<h4>These tags will automatically be added to the icons uploaded or pending uploads:</h4>");
                        results = [];
                        for (i = 0, len = keywords.length; i < len; i++) {
                            keyword = keywords[i];
                            results.push(group.append("<li><span class='keyword'>" + keyword + "</span></li>"));
                        }
                        return results;
                    }
                }
            }, {
                key: "saveKeywords",
                value: function saveKeywords(keywords) {
                    var keywords_ul = void 0;
                    var li = void 0;
                    var upload_id = void 0;
                    li = keywords.closest("li.icon-form");
                    upload_id = li.attr("data-upload-id");
                    keywords = {
                        suggested: li.find("input[name=suggested-noun]").val(),
                        terms: []
                    };
                    keywords_ul = li.find("ul.keywords .keyword").each(function (index) {
                        return keywords.terms.push((0, _jquery2.default)(this).text());
                    });
                    if (keywords.terms.length > 0) {
                        li.removeClass("too-few-tags");
                    }
                    (0, _jquery2.default)(".error-box").fadeOut();
                    if (upload_id !== "" && keywords.suggested !== "") {
                        return _jquery2.default.ajax({
                            method: "post",
                            data: {
                                upload_id: upload_id,
                                keywords: JSON.stringify(keywords),
                                license: li.find("input[name=license]:checked").val(),
                                collection_id: this.collection_id
                            },
                            url: "/upload/save-keywords/",
                            success: function success(data, status, xhr) {
                                return console.log(data);
                            }
                        });
                    }
                }
            }, {
                key: "deleteKeyword",
                value: function deleteKeyword(keyword, collection, icon_form) {
                    var li = void 0;
                    var si = void 0;
                    if (collection == null) {
                        collection = false;
                    }
                    si = this;
                    if (!collection) {
                        if (_jquery2.default.type(keyword) === "object") {
                            li = keyword.parent().parent("li");
                            li.remove();
                        } else {
                            icon_form.find(".keywords li .keyword").each(function () {
                                if ((0, _jquery2.default)(this).text() === keyword) {
                                    return si.deleteKeyword((0, _jquery2.default)(this).find("a.delete-keyword"));
                                }
                            });
                        }
                    }
                    if (collection) {
                        (0, _jquery2.default)(".icon-form").find(".keywords li .keyword").each(function () {

                            if ((0, _jquery2.default)(this).text() === keyword) {
                                return si.deleteKeyword((0, _jquery2.default)(this).find("a.delete-keyword"));
                            }
                        });
                        (0, _jquery2.default)(".icon-form").each(function () {
                            return si.saveKeywords((0, _jquery2.default)(this));
                        });
                        return this.saveCollection();
                    }
                }
            }, {
                key: "deleteIcon",
                value: function deleteIcon(icon) {
                    var li = void 0;
                    var si = void 0;
                    var upload_id = void 0;
                    si = this;
                    li = icon.parents("li");
                    upload_id = li.attr("data-upload-id");
                    if (upload_id !== "") {
                        _jquery2.default.ajax({
                            method: "post",
                            data: {
                                upload_id: upload_id
                            },
                            url: "/upload/delete-pending/",
                            success: function success(data, status, xhr) {}
                        });
                    }
                    li.addClass("remove");
                    return setTimeout(function () {
                        li.remove();
                        return si.checkNumUploads();
                    }, 600);
                }
            }, {
                key: "saveCollection",
                value: function saveCollection() {
                    var form = void 0;
                    form = (0, _jquery2.default)("form#create-collection-form");
                    form.attr("action", "/upload/collections/" + this.collection_id + "/update/");
                    if (this.collection_id) {
                        _jquery2.default.ajax({
                            method: "POST",
                            data: form.serialize(),
                            url: form.attr("action"),
                            success: function success(data) {
                                return console.log(data);
                            }
                        });
                    }
                    return console.log(this.collection_keywords());
                }
            }, {
                key: "createCollection",
                value: function createCollection(form, button) {
                    var formData = void 0;
                    var si = void 0;
                    si = this;
                    (0, _jquery2.default)(button).addClass("processing");

                    formData = form.serialize();

                    return _jquery2.default.ajax({
                        method: "POST",
                        url: "/upload/collections/create/",
                        data: formData,
                        success: function success(data) {
                            if (data.errors) {

                                si.createCollectionMessage(data.errors, data.field, form);
                                return (0, _jquery2.default)(button).removeClass("processing").addClass("failure");
                            } else {

                                si.collection_id = data.collection.id;
                                si.toggleDropZone(true);
                                (0, _jquery2.default)(button).hide();
                                return console.log("data collection id is", data.collection.id);
                            }
                        }
                    });
                }
            }, {
                key: "createCollectionMessage",
                value: function createCollectionMessage(message, field, form) {
                    var ccm = void 0;
                    var input = void 0;
                    if (field == null) {
                        field = "name";
                    }
                    ccm = (0, _jquery2.default)("#create-collection-message");
                    ccm.fadeIn(500);
                    ccm.text(message);
                    input = form.find("input[name=" + field + "]");
                    input.addClass("error");
                    input.focus();
                    return input.on("keyup", function () {
                        ccm.fadeOut(500);
                        return input.removeClass("error");
                    });
                }
            }, {
                key: "add_icon_form",
                value: function add_icon_form(data) {
                    var icon_form = void 0;
                    var nowUpload = void 0;
                    var tabindex = void 0;
                    data.iconCount = (0, _jquery2.default)(".icon-form").length;
                    icon_form = (0, _jquery2.default)(this.template(data));
                    tabindex = this.tabindex;

                    icon_form.find(".suggested-noun").attr("tabindex", tabindex);
                    icon_form.find(".keywords-field").attr("tabindex", tabindex + 1);
                    this.tabindex = tabindex + 2;
                    this.icon_forms.append(icon_form);
                    nowUpload = (0, _jquery2.default)(".now-upload-title");
                    if (!nowUpload.hasClass("hidden")) {
                        (0, _jquery2.default)(".uploading-info").removeClass("hidden");
                        nowUpload.addClass("hidden");
                        (0, _jquery2.default)(".now-name-title").removeClass("hidden");
                    }
                    return icon_form;
                }
            }, {
                key: "uploadFile",
                value: function uploadFile(fileData, icon_form) {
                    var collection_id = void 0;
                    var formData = void 0;
                    var si = void 0;
                    var upload_id = void 0;
                    si = this;

                    icon_form.addClass("uploading");
                    this.checkNumUploads();
                    upload_id = icon_form.data("upload-id");
                    collection_id = icon_form.data("collection-id");
                    formData = new FormData();

                    formData.append("svg", fileData);
                    if (collection_id) {
                        formData.append("collection_id", collection_id);
                    }
                    if (upload_id) {
                        formData.append("upload_id", upload_id);
                    }
                    if (this.brief_id) {
                        formData.append("brief_id", this.brief_id);
                    }
                    return _jquery2.default.ajax({
                        processData: false,
                        contentType: false,
                        method: "POST",
                        url: this.upload_url,
                        data: formData,
                        success: function success(data, status, xhr) {
                            var form = void 0;
                            var group = void 0;
                            var i = void 0;
                            var len = void 0;
                            var ref = void 0;
                            var tag = void 0;
                            var tags = void 0;
                            icon_form.removeClass("uploading");

                            if (data.error) {
                                icon_form.addClass("failed");
                                icon_form.find("input.suggested-noun").replaceWith("<div class='error-front'>We cannot accept this file: <div class='filename'>" + fileData.name + "</div></div>");
                                icon_form.find(".after-noun-added.flip-anchor").hide();

                                var svgErrors = [];
                                // List out each of the errors
                                svgErrors = data.error.map(function (error) {
                                    return "<li class=\"svg-error-item ui_close\">" + error + "</li>";
                                });
                                icon_form.find(".un-flip.ui_arrow-left-line").hide();
                                var preview_img_src = icon_form.find(".drop-target-preview-image").attr("src");
                                icon_form.find(".back .content").html("\n                                        <div style=\"width:70px;height:70px;display:block;margin:12px auto;\"><img src=\"" + preview_img_src + "\" width=\"70\" height=\"70\" alt=\"" + fileData.name + "\"></div>\n                                        <div class='filename'>" + fileData.name + "</div>\n                                        <div class='error'>\n                                            <div class=\"margin-t-xl margin-b-m\">\n                                                <ul class=\"svg-error-list\">\n                                                <li class=\"weight-medium\">Correct these errors before<br/> re-submitting this file:</li>\n                                                " + svgErrors.join("") + "\n                                                </ul>\n                                            </div>\n                                            <a href=\"/help/svgs/\" class=\"text-link light\" target=\"_blank\">Tips on how to fix SVGs</a>\n                                        </div>");
                                return icon_form.addClass("flip");
                            } else {
                                icon_form.attr("data-upload-id", data.upload_id);
                                icon_form.attr("data-collection-id", data.collection_id);
                                icon_form.find(".ccby-radio").attr("id", "ccby-" + data.upload_id);
                                icon_form.find(".ccby-label").attr("for", "ccby-" + data.upload_id);
                                icon_form.find(".cc0-radio").attr("id", "cc0-" + data.upload_id);
                                icon_form.find(".cc0-label").attr("for", "cc0-" + data.upload_id);
                                icon_form.find("img").attr("src", data.url);
                                icon_form.addClass("uploaded");
                                ref = si.pending_tags;
                                for (i = 0, len = ref.length; i < len; i++) {
                                    tag = ref[i];
                                    form = icon_form.find("form.icon-form-form");
                                    tags = form.serializeObject().tags || [];
                                    group = icon_form.find(".keywords");
                                    si.addKeyword(tag, group, tags, false);
                                }
                                si.saveKeywords(icon_form);
                                if (si.pending_license) {
                                    return si.collection_change_license(si.pending_license);
                                }
                            }
                        }
                    });
                }
            }, {
                key: "commit_pending_tags",
                value: function commit_pending_tags() {
                    var si = void 0;
                    si = this;
                    return (0, _jquery2.default)(".icon-form").each(function () {
                        var form = void 0;
                        var group = void 0;
                        var i = void 0;
                        var j = void 0;
                        var len = void 0;
                        var len1 = void 0;
                        var previous_tag = void 0;
                        var previous_tags = void 0;
                        var ref = void 0;
                        var tag = void 0;
                        var tags = void 0;
                        form = (0, _jquery2.default)(this).find("form.icon-form-form");
                        previous_tags = form.serializeObject().tags || [];
                        if (!Array.isArray(previous_tags)) {
                            previous_tags = [previous_tags];
                        }
                        group = (0, _jquery2.default)(this).find(".keywords");
                        for (i = 0, len = previous_tags.length; i < len; i++) {
                            previous_tag = previous_tags[i];
                            si.deleteKeyword(previous_tag, false, (0, _jquery2.default)(this));
                        }
                        tags = form.serializeObject().tags || [];
                        if (!Array.isArray(tags)) {
                            tags = [tags];
                        }
                        ref = si.pending_tags;
                        for (j = 0, len1 = ref.length; j < len1; j++) {
                            tag = ref[j];
                            si.addKeyword(tag, group, tags, false);
                        }
                        return si.saveKeywords((0, _jquery2.default)(this));
                    });
                }
            }, {
                key: "checkNumUploads",
                value: function checkNumUploads() {
                    var numOfUploads = void 0;
                    numOfUploads = this.icon_forms.find("li.icon-form").length;
                    if (numOfUploads > 0) {
                        this.dropZone.addClass("collapsed");
                        if (this.upload_individual) {
                            this.submit_icons.removeClass("hidden");
                        }
                        if (this.total_icons !== (0, _jquery2.default)(".card").length && this.total_icons !== 0) {
                            (0, _jquery2.default)(".load-more-icons ").removeClass("hidden");
                            return this.submit_icons.addClass("hidden");
                        } else {
                            (0, _jquery2.default)(".load-more-icons ").addClass("hidden");
                            return this.submit_icons.removeClass("hidden");
                        }
                    } else {
                        (0, _jquery2.default)(".load-more-icons ").addClass("hidden");
                        this.dropZone.removeClass("collapsed");
                        return this.submit_icons.addClass("hidden");
                    }
                }
            }, {
                key: "validate_icon_data",
                value: function validate_icon_data() {
                    var emptyTerm = void 0;
                    var icon_forms_lis = void 0;
                    var si = void 0;
                    var tooFewTags = void 0;
                    var uploadIds = void 0;
                    si = this;
                    uploadIds = [];
                    emptyTerm = [];
                    tooFewTags = [];
                    icon_forms_lis = si.icon_forms.find("li.icon-form");
                    icon_forms_lis.each(function () {
                        var form = void 0;
                        var tags = void 0;
                        var term = void 0;
                        var upload_id = void 0;
                        form = (0, _jquery2.default)(this);
                        form.removeClass("too-few-tags");
                        form.removeClass("empty-term");
                        upload_id = parseInt(form.attr("data-upload-id"));
                        if (upload_id) {
                            uploadIds.push(upload_id);
                            term = form.find(".suggested-noun").val();
                            if (term === "") {
                                emptyTerm.push(upload_id);
                            }
                            tags = form.find("ul.keywords .keyword").length;
                            if (tags < si.min_tags || tags > si.max_tags) {
                                return tooFewTags.push(upload_id);
                            }
                        }
                    });
                    if (emptyTerm.length + tooFewTags.length > 0) {
                        this.tagging_help(emptyTerm, tooFewTags);
                        return false;
                    }
                    return uploadIds;
                }
            }, {
                key: "tagging_help",
                value: function tagging_help(emptyTerm, tooFewTags) {
                    var card = void 0;
                    var i = void 0;
                    var j = void 0;
                    var len = void 0;
                    var len1 = void 0;
                    var results = void 0;
                    var uploadId = void 0;
                    (0, _jquery2.default)(".error-box").fadeIn();
                    for (i = 0, len = tooFewTags.length; i < len; i++) {
                        uploadId = tooFewTags[i];
                        if (emptyTerm.includes(uploadId)) {
                            continue;
                        }
                        card = (0, _jquery2.default)(".icon-form[data-upload-id=" + uploadId + "]");
                        card.addClass("flip");
                        card.addClass("too-few-tags");
                    }
                    results = [];
                    for (j = 0, len1 = emptyTerm.length; j < len1; j++) {
                        uploadId = emptyTerm[j];
                        card = (0, _jquery2.default)(".icon-form[data-upload-id=" + uploadId + "]");
                        card.removeClass("flip");
                        results.push(card.addClass("empty-term"));
                    }
                    return results;
                }
            }, {
                key: "toggleDropZone",
                value: function toggleDropZone(state) {
                    if (state) {
                        this.dropZone.removeClass("hidden");
                        this.lowerHalf.removeClass("hidden");
                        if (this.collection_id) {
                            return this.submit_icons.removeClass("hidden");
                        }
                    } else {
                        this.dropZone.addClass("hidden");
                        this.submit_icons.addClass("hidden");
                        return this.lowerHalf.addClass("hidden");
                    }
                }
            }]);

            return SubmitIcons;
        }();

        return SubmitIcons;
    }();
    start = function start(upload_type, brief_id) {
        var si = void 0;
        si = new SubmitIcons("#upload-process", upload_type, brief_id);
        si._init();
        return _jquery2.default.ajax({
            url: "/upload/pending/",
            data: {
                brief_id: brief_id
            },
            success: function (_this) {
                return function (_ref8) {
                    var icons = _ref8.icons,
                        total_icons = _ref8.total_icons;

                    si.page = 1;
                    return si.set_pending_icons(icons, total_icons);
                };
            }(this)
        });
    };
    window.initUploads = start;
    new Upload_Carousel((0, _jquery2.default)(".carousel"));
};

exports.default = Upload;